import React from 'react';
import "../../css/pp-sect2.css";
import Sect2Ill2LG from "../../assets/images/lp-sect5-img.png";
import Sect2Ill2SM from "../../assets/images/parentPage-sect2-img-sm.png";
import { ReactComponent as Sect2Icon1 } from "../../assets/icons/parentPage-sect2-icon1.svg";
import { ReactComponent as Sect2Icon2 } from "../../assets/icons/parentPage-sect2-icon2.svg";
import { ReactComponent as Sect2Icon3 } from "../../assets/icons/parentPage-sect2-icon3.svg";

const Sect2 = () => {
  return (
    <section id="pp-sect2">
      <article>
        <div>
          <h2>
            Track and see your child/ward progress as they study, from anywhere
          </h2>
          <img className="pp-sect2-ill-lg" src={Sect2Ill2LG} alt="" />
          <img className="pp-sect2-ill-sm" src={Sect2Ill2SM} alt="" />
          <p>
            Our philosophy is simple — hire a team of diverse, passionate people
            and foster a culture that empowers you to do you best work.
          </p>
        </div>
        <div>
          <div>
            <Sect2Icon1 className="pp-sect2-icon" />
            <h3>Measure your performance</h3>
            <p>
              Stay connected with your team and make quick decisions wherever
              <br />
              you are.
            </p>
          </div>
          <div>
            <Sect2Icon2 className="pp-sect2-icon" />
            <h3>Custom analytics</h3>
            <p>
              Get a complete sales dashboard in the cloud. See activity, revenue
              and social metrics all in one place.
            </p>
          </div>
          <div>
            <Sect2Icon3 className="pp-sect2-icon" />
            <h3>Team Management</h3>
            <p>
              Our calendar lets you know what is happening with customer and
              projects so you
            </p>
          </div>
        </div>
      </article>
    </section>
  );
};

export default Sect2;